import gql from 'graphql-tag';
export default gql`
  mutation getEnvelope {
    getEnvelope {
      status
    }
  }
`;
